import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { FeaturePeriodModule } from '@unpispas/feature/period';
import { FeatureQrCodeModule }  from '@unpispas/feature/qrcode';
import { FeatureProductModule }  from '@unpispas/feature/product';

import { UppExtraThumbComponent } from '../components/thumb/upp-thumb';
import { UppExtraEditComponent } from '../components/edit/upp-edit';
import { UppExtraProductComponent } from '../components/product/upp-item';
import { UppExtraTicketComponent } from '../components/ticket/upp-ticket';

@NgModule({
    declarations: [
        UppExtraThumbComponent,
        UppExtraEditComponent,
        UppExtraProductComponent,
        UppExtraTicketComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
        FeaturePeriodModule,       
        FeatureQrCodeModule,
        FeatureProductModule
    ],
    exports: [
        UppExtraThumbComponent,
        UppExtraEditComponent,
        UppExtraTicketComponent
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureExtraModule {}

